import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { doFetch } from '../redux/api/actions';
import { CATEGORIES, ME } from '../redux/api/constants';
import { Link, useNavigate } from 'react-router-dom';
import withLayout from './withLayout';
import { MakeSearchBar, doSearch } from "./searchbar";


function CategoryGrid({ categories }) {
    return (
        <div className="row row-cols-1 row-cols-md-3 g-4 mt-3">
            {categories && categories.map((category, index) => (
                <div className="col" key={index}>
                    <Link to={`/categories/${category.id}`} className="text-decoration-none text-dark">
                        <div className="card h-100">
                            {category.photo_file_name && (
                                <img
                                    src={category.photo_file_name}
                                    className="card-img-top"
                                    alt={category.title}
                                    style={{ objectFit: "cover", height: "180px" }}
                                />
                            )}
                            <div className="card-body">
                                <h5 className="card-title">{category.title}</h5>
                            </div>
                        </div>
                    </Link>
                </div>
            ))}
        </div>
    );
}


function Home() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authToken = useSelector(state => state.Auth.accessToken);
    const categories = useSelector(state => state.API.categories);
    const me = useSelector(state => state.API.me);

    useEffect(() => {
        if (authToken) {
            dispatch(doFetch(ME, 'users/me', authToken));
        }
    }, [dispatch, authToken]);

    useEffect(() => {
        dispatch(doFetch(CATEGORIES, 'categories'));
    }, [dispatch]);

    return (
        <div className="container min-vh-100">
            <div className="py-5 text-center">
                <h1 className="display-4">Welcome to CookingWright</h1>
                <p className="lead">The Wright family cookbook — made with love and shared with generations.</p>
            </div>

            <MakeSearchBar searchFunc={(keyword) => doSearch(navigate, keyword)} />

            <CategoryGrid categories={categories} />

            {me && (
                <div className="text-center mt-5">
                    <Link to="/recipes/new" className="btn btn-lg btn-success">
                        🍴 Add a New Family Recipe
                    </Link>
                </div>
            )}
        </div>
    );
}

export default withLayout(Home);